import "core-js";
import "whatwg-fetch";
import "abortcontroller-polyfill/dist/polyfill-patch-fetch";
// Order matters: AbortController needs fetch which needs Promise (provided by core-js).
import "md-gum-polyfill";

import Uppy from "@uppy/core";
import Transloadit from "@uppy/transloadit";
import Dashboard from "@uppy/dashboard";
import AwsS3 from "@uppy/aws-s3";

require("@uppy/core/dist/style.min.css");
require("@uppy/dashboard/dist/style.min.css");

document.addEventListener("alpine:init", () => {
    Alpine.data("new_edit_youtube_episode_x_data", () => ({
        init() {
            uppy_episode_video(this);
            // uppy_cover_art(this);
            uppy_youtube_thumbnail(this);
            externalJS(this);
            this.set_data();
            this.check_audio_episode_published();
            this.load_playlists();
            this.restore_playlist_selection();
            this.restore_youtube_thumbnail();
            this.init_publishing_state();
            this.init_privacy_selection();
            this.check_success_modal();
        },
        video_upload: false,
        audio_upload: false,
        cover_art_upload: false,
        cover_art_error_msg: "",
        save_text: "",
        audio_error: "",
        title_error: "",
        keyword_error: "",
        description_error: "",
        season_error: "",
        episode_number_error: "",
        episode_errors: [],
        schedule_error: "",
        /**
         * Keeps title and keyword validation beside their fields and other errors in the
         * existing page summary.
         *
         * @param {Object|Array|string} reason
         * @returns {void}
         */
        apply_submission_errors(reason) {
            if (!reason || Array.isArray(reason) || typeof reason !== "object") {
                this.title_error = "";
                this.keyword_error = "";
                this.episode_errors = typeof reason === "string" && reason ? [reason] : (reason || []);
                return;
            }

            const remainingErrors = { ...reason };
            const titleErrors = remainingErrors.title;
            const keywordErrors = remainingErrors.keywords;
            delete remainingErrors.title;
            delete remainingErrors.keywords;

            this.title_error = Array.isArray(titleErrors) ? (titleErrors[0] || "") : (titleErrors || "");
            this.keyword_error = Array.isArray(keywordErrors) ? keywordErrors.join(" ") : (keywordErrors || "");
            this.episode_errors = Object.keys(remainingErrors).length === 0 ? [] : remainingErrors;
        },
        /**
         * Checks the server's keyword limits without changing the entered value.
         * @returns {boolean} Whether publishing or updating may proceed.
         */
        validate_youtube_keywords() {
            const field = document.querySelector("#app_youtube_episode_keywords");
            const raw = field.value;
            // Match Ruby String#strip; JavaScript trim also removes valid Unicode spaces.
            const tags = raw.split(",").map((tag) => tag.replace(/^[\x00\t\n\v\f\r ]+|[\x00\t\n\v\f\r ]+$/g, "")).filter(Boolean);
            const errors = [];
            if (tags.some((tag) => Array.from(tag).length > 100)) {
                errors.push("Each keyword must be 100 characters or fewer.");
            }
            const count = tags.reduce((total, tag) => total + Array.from(tag).length + (tag.includes(" ") ? 2 : 0), 0)
                + Math.max(tags.length - 1, 0);
            if (count > 500) {
                errors.push("Keywords must total 500 characters or fewer.");
            }
            const fragment = document.createElement("template");
            fragment.innerHTML = raw;
            if (/[\r\n\u2022\u25e6\u25aa\u2023\u2043\u2219\u25cf\u25cb\u25a0\u25a1]/.test(raw) || fragment.content.children.length > 0) {
                errors.push("Keywords can\u2019t contain HTML, line breaks, or bullet points.");
            }
            this.keyword_error = errors.join(" ");
            if (errors.length) {
                (field.tomselect ? field.tomselect.wrapper : field).scrollIntoView({ behavior: "smooth", block: "center" });
            }
            return errors.length === 0;
        },
        /**
         * Preserves an explicit clear through every single-editor submission path.
         * @param {HTMLFormElement} form
         * @returns {FormData} Current fields, including empty optional keywords.
         */
        youtube_form_data(form) {
            const data = new FormData(form);
            data.set("app_youtube_episode[keywords][]", document.querySelector("#app_youtube_episode_keywords").value);
            return data;
        },
        category_error: "",
        original_audio_file_name: "",
        audio_file_name: "",
        video_file_name: "",
        draft_text: "Save as Draft",
        draft_disabled: false,
        continue_to_audio_text: "Go to audio set-up",
        continue_to_audio_disabled: false,
        submit_disabled: false,
        update_disabled: false,
        background_upload_text: "",
        background_video_upload_text: "",
        replace_audio_clicked: false,
        replace_video_clicked: false,
        keyword_exists: false,
        contributor_exists: false,
        audio_assembly_id: "",
        cover_art_assembly_id: "",
        original_pub_date: "",
        pub_date_error: "",
        // RSS feed modals removed - not applicable to YouTube episodes
        download_audio_fn: null,
        download_video_fn: null,
        selected_playlist: '',
        new_playlist_modal: false,
        new_playlist_name: '',
        new_playlist_description: '',
        new_playlist_privacy: 'private',
        playlists: [],
        playlists_loading: false,
        playlists_error: '',
        playlist_error: '',
        create_playlist_loading: false,
        playlist_cover_art_url: '',
        playlist_cover_art_file: null,
        playlist_image_error: '',
        playlist_name_error: '',
        playlist_description_error: '',
        using_show_cover_art: false,
        privacy_error: '',
        privacy_disabled: false,
        selected_privacy_option: '',
        publish_now_visibility_preference: 'private', // Store user's preference for publish now mode
        current_video_file_info: null,
        // YouTube thumbnail system (separate from episode cover art)
        youtube_thumbnail_uploaded: false,
        youtube_thumbnail_url: '',
        youtube_thumbnail_error: '',
        // Video to audio conversion modal
        video_to_audio_modal: false,
        audio_choice: 'upload_own', // 'convert_video' or 'upload_own'
        audio_episode_published: false, // Track if audio episode is already published
        // Replace video modal
        replace_video_modal: false,
        replace_video_error: '',
        // Save as draft modal
        save_as_draft_modal: false,
        // Update episode modal
        update_episode_modal: false,
        // Audio file ready confirmation modal
        audio_file_ready_modal: false,
        // Success modal for youtube_and_audio episodes
        success_modal: false,
        modal_header: '',
        modal_body: '',
        modal_secondary_body: '',
        modal_actions: [],
        // Episode state management
        is_scheduled_or_published: false,
        episode_stage: '',
        // YouTube connection status
        youtube_connected: false,
        check_create() {
            if (this.selected_playlist === '__create__') {
                this.new_playlist_modal = true;
                this.selected_playlist = ''; // reset select to prevent accidental resubmission
            }
        },
        handle_playlist_selection() {
            // When playlist is selected, save playlist info to episode data
            if (this.selected_playlist && this.selected_playlist !== '__create__') {
                const selectedPlaylistData = this.playlists.find(p => p.id === this.selected_playlist);
                if (selectedPlaylistData) {
                    // Store playlist info for persistence
                    const hiddenPlaylistInfoField = document.querySelector('#youtube_playlist_info');
                    if (hiddenPlaylistInfoField) {
                        hiddenPlaylistInfoField.value = JSON.stringify(selectedPlaylistData);
                    }

                    // Also store the playlist ID in the dedicated field
                    const hiddenPlaylistIdField = document.querySelector('#youtube_playlist_id');
                    if (hiddenPlaylistIdField) {
                        hiddenPlaylistIdField.value = selectedPlaylistData.id;
                    }
                }
            }
        },
        handle_privacy_change() {
            // Clear publishing errors when user changes selection
            this.clear_publishing_errors();

            // Update selected privacy option for helper text display
            const privacyField = document.querySelector('input[name="app_youtube_episode[visibility_settings]"]:checked');
            if (privacyField) {
                this.selected_privacy_option = privacyField.value;
            }

            // Check if scheduled and privacy is not private
            const scheduleField = document.querySelector('#ql-schedule-later');

            if (scheduleField && scheduleField.checked && privacyField && privacyField.value !== 'private') {
                this.privacy_error = 'Scheduled videos must be set to private';
            }
        },
        handle_schedule_change() {
            // Clear schedule error
            this.schedule_error = '';

            const scheduleField = document.querySelector('#ql-schedule-later');
            const privateField = document.querySelector('input[name="app_youtube_episode[visibility_settings]"][value="private"]');
            const publishModeField = document.querySelector('#publish_mode');

            if (scheduleField && scheduleField.checked) {
                // Scheduled video selected - save current visibility preference and force private
                const currentVisibility = document.querySelector('input[name="app_youtube_episode[visibility_settings]"]:checked');
                if (currentVisibility && currentVisibility.value !== 'private') {
                    this.publish_now_visibility_preference = currentVisibility.value;
                }

                // Update publish_mode field
                if (publishModeField) {
                    publishModeField.value = 'scheduled';
                }

                // Auto-select private option (hidden from user but still selected)
                if (privateField) {
                    privateField.checked = true;
                    this.selected_privacy_option = 'private';
                }
                this.privacy_disabled = true;
                this.privacy_error = '';
            } else {
                // Publish now selected - restore user's preferred visibility
                if (publishModeField) {
                    publishModeField.value = 'publish_now';
                }

                // Restore their preferred visibility
                const preferredField = document.querySelector(`input[name="app_youtube_episode[visibility_settings]"][value="${this.publish_now_visibility_preference}"]`);
                if (preferredField) {
                    preferredField.checked = true;
                    this.selected_privacy_option = this.publish_now_visibility_preference;
                }

                this.privacy_disabled = false;
                this.privacy_error = '';
            }
        },
        restore_playlist_selection() {
            // Restore playlist selection from draft data if available
            const hiddenPlaylistInfoField = document.querySelector('#youtube_playlist_info');
            const hiddenPlaylistIdField = document.querySelector('#youtube_playlist_id');

            // First try to restore from youtube_playlist_id field
            if (hiddenPlaylistIdField && hiddenPlaylistIdField.value) {
                this.selected_playlist = hiddenPlaylistIdField.value;
                return;
            }

            // If youtube_playlist_id is empty, try to restore from youtube_playlist_info
            if (hiddenPlaylistInfoField && hiddenPlaylistInfoField.value) {
                try {
                    const playlistInfo = JSON.parse(hiddenPlaylistInfoField.value);
                    if (playlistInfo && playlistInfo.id) {
                        this.selected_playlist = playlistInfo.id;
                    }
                } catch (error) {
                    console.error('Failed to parse playlist info:', error);
                }
            }
        },
        init_privacy_selection() {
            // Initialize the selected privacy option for helper text display
            const privacyField = document.querySelector('input[name="app_youtube_episode[visibility_settings]"]:checked');
            if (privacyField) {
                this.selected_privacy_option = privacyField.value;

                // If this is publish_now mode, store the current visibility as their preference
                const publishModeField = document.querySelector('#publish_mode');
                if (publishModeField && publishModeField.value === 'publish_now') {
                    this.publish_now_visibility_preference = privacyField.value;
                }
            }
        },
        validate_privacy_for_schedule() {
            // Check if schedule and privacy settings are compatible
            const scheduleField = document.querySelector('#ql-schedule-later');
            const privacyField = document.querySelector('input[name="app_youtube_episode[visibility_settings]"]:checked');

            if (scheduleField && scheduleField.checked && privacyField && privacyField.value !== 'private') {
                this.privacy_error = 'Scheduled videos must be set to private';
                return false;
            }

            this.privacy_error = '';
            return true;
        },
        validate_youtube_publishing_requirements() {
            // Comprehensive YouTube publishing validation
            // Clear previous errors
            this.privacy_error = '';
            this.category_error = '';
            this.playlist_error = '';
            this.title_error = '';
            this.description_error = '';
            this.audio_error = '';
            this.schedule_error = '';

            // Check if YouTube is connected
            const dataEl = document.getElementById("ql-data-points");
            const playlistApiUrl = dataEl.dataset.playlistApiUrl;

            if (!playlistApiUrl) {
                this.privacy_error = 'YouTube account not connected. Please connect your YouTube account in Distribution settings.';
                document.querySelector("#youtube-visibility-section").scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
                return false;
            }
            // 1. Check if video is uploaded FIRST
            const video_url = dataEl.dataset.videoUrl;
            const youtube_video_id = dataEl.dataset.youtubeVideoId;
            const episode_stage = dataEl.dataset.episodeStage;

            // Video is considered uploaded if:
            // - There's a processed video URL, OR
            // - There's a YouTube video ID for published episodes, OR
            // - The video_upload flag is true (for newly uploaded videos)
            const hasProcessedVideo = video_url && video_url !== "";
            const hasYoutubeVideo = youtube_video_id && youtube_video_id !== "" && episode_stage !== "draft";
            const hasUploadedVideo = this.video_upload === true;

            if (!hasProcessedVideo && !hasYoutubeVideo && !hasUploadedVideo) {
                this.audio_error = 'Please upload a video file';
                document.querySelector("#video_section").scrollIntoView({behavior: "smooth", block: "center"});
                return false;
            }

            // 2. Check if title is provided
            const titleField = document.querySelector('input[name="app_youtube_episode[title]"]');
            if (!titleField || titleField.value.trim() === '') {
                this.title_error = 'Please enter a title for your YouTube video';
                if (titleField) {
                    titleField.scrollIntoView({behavior: "smooth", block: "center"});
                }
                return false;
            }

            // 3. Check if description is provided
            const descriptionField = document.querySelector('#app_youtube_episode_description');
            if (!descriptionField || descriptionField.value.trim() === '' || descriptionField.value.trim() === '<p><br></p>') {
                this.description_error = 'Please enter a description for your YouTube video';
                // Scroll to the visible Quill editor, not the hidden field
                const quillEditor = document.querySelector('.ql-editor');
                if (quillEditor) {
                    quillEditor.scrollIntoView({behavior: "smooth", block: "center"});
                }
                return false;
            }

            // 4. Check if playlist is selected (now required)
            if (!this.selected_playlist || this.selected_playlist === '') {
                this.playlist_error = 'Please select a playlist for your YouTube video';
                const playlistField = document.querySelector('[x-model="selected_playlist"]');
                if (playlistField) {
                    playlistField.scrollIntoView({behavior: "smooth", block: "center"});
                }
                return false;
            }

            // 5. Check if category is selected
            const categoryField = document.querySelector('select[name="app_youtube_episode[category]"]');
            if (!categoryField || categoryField.value === '') {
                this.category_error = 'Please select a category for your YouTube video';
                if (categoryField) {
                    categoryField.scrollIntoView({behavior: "smooth", block: "center"});
                }
                return false;
            }

            // 6. Check if visibility settings are selected
            const privacyField = document.querySelector('input[name="app_youtube_episode[visibility_settings]"]:checked');
            if (!privacyField) {
                this.privacy_error = 'Please select a visibility setting for your YouTube video';
                document.querySelector("#youtube-visibility-section").scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
                return false;
            }

            // 6. Check if scheduling is selected and validate requirements
            const scheduleField = document.querySelector('#ql-schedule-later');
            const scheduleDateField = document.querySelector('#app_youtube_episode_scheduled_at_time');

            if (scheduleField && scheduleField.checked) {
                // Check if scheduled date is provided
                if (!scheduleDateField || scheduleDateField.value === '') {
                    this.schedule_error = 'Please select a date to schedule your episode.';
                    if (scheduleDateField) {
                        scheduleDateField.scrollIntoView({behavior: "smooth", block: "center"});
                    }
                    return false;
                }

                // Check if privacy is set to private for scheduled videos
                if (privacyField.value !== 'private') {
                    this.privacy_error = 'Scheduled videos must be set to private';
                    document.querySelector("#youtube-visibility-section").scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                    });
                    return false;
                }
            }

            // 7. Check content made for kids setting
            const contentForKidsField = document.querySelector('input[name="app_youtube_episode[content_made_for_kids]"]:checked');
            if (!contentForKidsField) {
                this.privacy_error = 'Please indicate if this content is made for kids (YouTube requirement)';
                document.querySelector("#youtube-visibility-section").scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
                return false;
            }
            return this.validate_youtube_keywords();
        },
        clear_publishing_errors() {
            // Clear all publishing-related errors when user makes changes
            this.privacy_error = '';
            this.category_error = '';
            this.playlist_error = '';
            this.title_error = '';
            this.keyword_error = '';
            this.description_error = '';
            this.audio_error = '';
            this.schedule_error = '';
        },
        copy_from_show_settings() {
            const dataEl = document.getElementById("ql-data-points");

            // Copy show data to playlist fields
            this.new_playlist_name = dataEl.dataset.showTitle || '';
            this.new_playlist_description = dataEl.dataset.showDescription || '';

            // Validate show cover art using metadata
            const showCoverArtUrl = dataEl.dataset.showCoverArtUrl;
            const coverArtDataStr = dataEl.dataset.showCoverArtData;

            if (!showCoverArtUrl || !coverArtDataStr) {
                this.playlist_image_error = 'Show cover art is required';
                return;
            }

            try {
                const coverArtData = JSON.parse(coverArtDataStr);
                const metadata = coverArtData.metadata;

                if (!metadata) {
                    this.playlist_image_error = 'Show cover art metadata not available';
                    return;
                }

                // Validate format (JPEG/PNG only)
                if (!['image/jpeg', 'image/png'].includes(metadata.mime_type)) {
                    this.playlist_image_error = 'Show cover art must be JPEG or PNG format';
                    return;
                }

                // Validate size (max 2MB)
                if (metadata.size > 2 * 1024 * 1024) {
                    this.playlist_image_error = 'Show cover art is too large (max 2MB)';
                    return;
                }

                // All validations passed
                this.playlist_cover_art_url = showCoverArtUrl;
                this.using_show_cover_art = true;
                this.playlist_image_error = '';

                // Update preview
                const previewImg = document.getElementById('playlist-cover-preview');
                if (previewImg) {
                    previewImg.src = showCoverArtUrl;
                    previewImg.style.display = 'block';
                }

            } catch (error) {
                console.error('Error parsing cover art data:', error);
                this.playlist_image_error = 'Invalid show cover art metadata';
            }
        },
        handle_playlist_cover_upload(event) {
            const file = event.target.files[0];
            if (!file) return;

            this.playlist_image_error = '';

            // Validate file type (only JPEG and PNG)
            if (!['image/jpeg', 'image/png'].includes(file.type)) {
                this.playlist_image_error = 'Only JPEG and PNG images are supported';
                return;
            }

            // Validate file size (max 2MB)
            if (file.size > 2 * 1024 * 1024) {
                this.playlist_image_error = 'Image must be less than 2MB';
                return;
            }

            // Store file for upload and override show cover art
            this.playlist_cover_art_file = file;
            this.using_show_cover_art = false; // User uploaded file takes priority

            // Create preview and validate aspect ratio
            const reader = new FileReader();
            reader.onload = (e) => {
                const img = new Image();
                img.onload = () => {
                    // Validate aspect ratio (must be square 1:1)
                    if (img.width !== img.height) {
                        this.playlist_image_error = 'Image must be square (1:1 aspect ratio). Current size: ' + img.width + 'x' + img.height;
                        this.playlist_cover_art_file = null;
                        this.playlist_cover_art_url = '';
                        return;
                    }

                    // All validations passed
                    this.playlist_cover_art_url = e.target.result;
                    this.playlist_image_error = '';

                    // Update preview image
                    const previewImg = document.getElementById('playlist-cover-preview');
                    if (previewImg) {
                        previewImg.src = e.target.result;
                        previewImg.style.display = 'block';
                    }
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        set_youtube_thumbnail_data() {
            // Initialize YouTube thumbnail from episode data (separate from cover art)
            const dataEl = document.getElementById("ql-data-points");
            const youtube_thumbnail_url = dataEl.dataset.youtubeThumbnailUrl;

            // Check if we have a stored S3 key (starts with "video/") or a full URL
            if (youtube_thumbnail_url && youtube_thumbnail_url !== "") {
                this.youtube_thumbnail_uploaded = true;

                // If it's an S3 key (not a full URL), we'll generate download URL in restore_youtube_thumbnail
                // If it's already a URL, use it directly for now
                if (youtube_thumbnail_url.startsWith('video/')) {
                    // This is an S3 key, we'll need to generate a download URL
                    this.youtube_thumbnail_url = youtube_thumbnail_url; // Store the key temporarily
                } else {
                    // This is already a download URL
                    this.youtube_thumbnail_url = youtube_thumbnail_url;
                }
            } else {
                this.youtube_thumbnail_uploaded = false;
                this.youtube_thumbnail_url = '';
            }
        },
        async restore_youtube_thumbnail() {
            // Restore thumbnail preview from S3 when returning to the page
            if (this.youtube_thumbnail_uploaded && this.youtube_thumbnail_url) {
                try {
                    // If we already have a full download URL, just use it
                    if (!this.youtube_thumbnail_url.startsWith('video/')) {
                        const thumbnailPreview = document.getElementById("youtube-thumbnail-preview");
                        if (thumbnailPreview) {
                            thumbnailPreview.src = this.youtube_thumbnail_url;
                        }
                        return;
                    }

                    // We have an S3 key, need to generate download URL
                    const dataEl = document.getElementById("ql-data-points");
                    const downloadUrlEndpoint = dataEl.dataset.youtubeThumbnailDownloadUrl;

                    const response = await fetch(downloadUrlEndpoint, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                        },
                        body: JSON.stringify({
                            content_type: 'image/jpeg',
                            backup_thumbnail_key: this.youtube_thumbnail_url // Send the S3 key
                        })
                    });

                    const data = await response.json();

                    if (data.download_url) {
                        this.youtube_thumbnail_url = data.download_url;

                        // Update preview element
                        const thumbnailPreview = document.getElementById("youtube-thumbnail-preview");
                        if (thumbnailPreview) {
                            thumbnailPreview.src = data.download_url;
                        }
                    }
                } catch (error) {
                    console.error("Error restoring YouTube thumbnail:", error);
                    this.youtube_thumbnail_uploaded = false;
                    this.youtube_thumbnail_url = '';
                }
            }
        },
        handle_youtube_thumbnail_upload(event) {
            // Clear any previous error
            this.youtube_thumbnail_error = '';

            // Check if YouTube is connected for published/scheduled episodes
            if (this.is_scheduled_or_published && !this.youtube_connected) {
                // Set error message
                this.youtube_thumbnail_error = 'YouTube account must be connected to set the thumbnail';
                // Scroll to YouTube connection banner
                this.scroll_to_youtube_banner();
                // Prevent the Uppy modal from opening
                if (event) {
                    event.stopPropagation();
                    event.preventDefault();
                }
            }

            // For draft episodes or when YouTube is connected, let the click go through to Uppy
            // The click will bubble up and trigger the Uppy modal
        },
        async remove_youtube_thumbnail() {
            // Check if YouTube is connected for published/scheduled episodes
            if (this.is_scheduled_or_published && !this.youtube_connected) {
                // Set error message
                this.youtube_thumbnail_error = 'YouTube account must be connected to replace the thumbnail';
                // Scroll to YouTube connection banner
                this.scroll_to_youtube_banner();
                return;
            }

            // For published/scheduled episodes, trigger replace flow
            if (this.is_scheduled_or_published) {
                // Store the current thumbnail info for comparison
                this.previous_thumbnail_url = this.youtube_thumbnail_url;
                this.previous_thumbnail_extension = this.get_file_extension(this.youtube_thumbnail_url);

                // Don't clear UI or preview - keep showing current thumbnail

                // Trigger Uppy modal immediately
                const uppyTrigger = document.getElementById("youtube-thumbnail-uppy-trigger");
                if (uppyTrigger) {
                    uppyTrigger.click();
                }
            } else {
                // Draft mode
                this.youtube_thumbnail_uploaded = false;
                this.youtube_thumbnail_url = '';
                this.youtube_thumbnail_error = '';

                // Clear preview
                const thumbnailPreview = document.getElementById("youtube-thumbnail-preview");
                if (thumbnailPreview) {
                    thumbnailPreview.src = '';
                }

                // Clear the hidden form field so empty value gets saved to database
                const thumbnailUrlField = document.querySelector('#youtube_thumbnail_url');
                if (thumbnailUrlField) {
                    thumbnailUrlField.value = '';
                }

                // Mark that thumbnail has changed (removed in this case)
                const thumbnailChangedField = document.getElementById('youtube_thumbnail_changed');
                if (thumbnailChangedField) {
                    thumbnailChangedField.value = 'true';
                }

                // Delete from S3
                try {
                    const dataEl = document.getElementById("ql-data-points");
                    const deleteUrlEndpoint = dataEl.dataset.youtubeThumbnailDeleteUrl;

                    await fetch(deleteUrlEndpoint, {
                        method: 'DELETE',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                        },
                        body: JSON.stringify({
                            content_type: 'image/jpeg'
                        })
                    });
                } catch (error) {
                    console.error("Error deleting YouTube thumbnail:", error);
                }
            }
        },
        get_file_extension(url) {
            if (!url) return '';
            const matches = url.match(/\.([a-zA-Z0-9]+)(?:\?|$)/);
            return matches ? matches[1].toLowerCase() : '';
        },
        async load_playlists() {
            const dataEl = document.getElementById("ql-data-points");
            const playlistApiUrl = dataEl.dataset.playlistApiUrl;

            if (!playlistApiUrl) {
                this.playlists_error = 'YouTube not connected';
                return;
            }

            this.playlists_loading = true;
            this.playlists_error = '';

            try {
                const response = await fetch(playlistApiUrl, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                    }
                });

                const data = await response.json();

                if (data.success) {
                    this.playlists = data.playlists;
                    this.update_playlist_dropdown();

                    // Set selected playlist after loading if episode has youtube_playlist_id
                    this.set_selected_playlist_after_loading();
                } else {
                    this.playlists_error = data.error || 'Failed to load playlists';
                    if (data.requires_reauth) {
                        this.playlists_error = 'YouTube authorization expired. Please reconnect your account.';
                    }
                }
            } catch (error) {
                console.error('Error loading playlists:', error);
                this.playlists_error = 'Failed to load playlists';
            } finally {
                this.playlists_loading = false;
            }
        },

        update_playlist_dropdown() {
            const select = document.querySelector('[x-model="selected_playlist"]');
            if (!select) return;

            // Clear existing options except the first placeholder and create option
            const options = select.querySelectorAll('option');
            options.forEach((option, index) => {
                if (index > 0 && option.value !== '__create__') {
                    option.remove();
                }
            });

            // Add playlists from API
            this.playlists.forEach(playlist => {
                const option = document.createElement('option');
                option.value = playlist.id;
                option.text = playlist.title;

                // Insert before the "Create new playlist" option
                const createOption = select.querySelector('option[value="__create__"]');
                select.insertBefore(option, createOption);
            });
        },

        set_selected_playlist_after_loading() {
            // Set selected playlist after playlists are loaded if episode has youtube_playlist_id
            const hiddenPlaylistIdField = document.querySelector('#youtube_playlist_id');
            const hiddenPlaylistInfoField = document.querySelector('#youtube_playlist_info');

            let playlistIdToSelect = null;

            // First try to get from youtube_playlist_id field
            if (hiddenPlaylistIdField && hiddenPlaylistIdField.value) {
                playlistIdToSelect = hiddenPlaylistIdField.value;
            }
            // If youtube_playlist_id is empty, try to get from youtube_playlist_info
            else if (hiddenPlaylistInfoField && hiddenPlaylistInfoField.value) {
                try {
                    const playlistInfo = JSON.parse(hiddenPlaylistInfoField.value);
                    if (playlistInfo && playlistInfo.id) {
                        playlistIdToSelect = playlistInfo.id;
                    }
                } catch (error) {
                    console.error('Failed to parse playlist info:', error);
                }
            }

            // If we have a playlist ID to select, check if it exists in the loaded playlists
            if (playlistIdToSelect) {
                const playlistExists = this.playlists.find(playlist => playlist.id === playlistIdToSelect);
                if (playlistExists) {
                    // Set both the Alpine data and force the select element to update
                    this.selected_playlist = playlistIdToSelect;

                    // Also update the actual select element's value to ensure it's reflected in the UI
                    this.$nextTick(() => {
                        const selectElement = document.querySelector('[x-model="selected_playlist"]');
                        if (selectElement) {
                            selectElement.value = playlistIdToSelect;
                            selectElement.dispatchEvent(new Event('change'));
                        }
                    });
                } else {
                    console.warn('Playlist ID not found in loaded playlists:', playlistIdToSelect);
                }
            }
        },

        async create_playlist() {
            // Clear previous errors
            this.playlist_name_error = '';
            this.playlist_description_error = '';
            this.playlist_image_error = '';

            if (!this.new_playlist_name.trim()) {
                this.playlist_name_error = 'Playlist name is required';
                return;
            }

            if (!this.new_playlist_description.trim()) {
                this.playlist_description_error = 'Playlist description is required';
                return;
            }

            // Check if playlist title already exists
            const trimmedTitle = this.new_playlist_name.trim();
            const existingPlaylist = this.playlists.find(playlist =>
                playlist.title.toLowerCase() === trimmedTitle.toLowerCase()
            );

            if (existingPlaylist) {
                this.playlist_name_error = 'A playlist with that title already exists';
                return;
            }

            if (!this.playlist_cover_art_file && !this.using_show_cover_art) {
                this.playlist_image_error = 'Playlist image is required';
                return;
            }

            const dataEl = document.getElementById("ql-data-points");
            const createPlaylistApiUrl = dataEl.dataset.createPlaylistApiUrl;

            if (!createPlaylistApiUrl) {
                alert('YouTube not connected');
                return;
            }

            this.create_playlist_loading = true;
            this.playlist_image_error = '';

            // Prevent page navigation during creation
            window.addEventListener('beforeunload', this.preventPageLeave);
            document.addEventListener('turbo:before-visit', this.preventTurboNavigation);

            try {
                let playlistImageUrl = null;

                // Step 1: Upload image to S3 if using uploaded file
                if (this.playlist_cover_art_file) {
                    playlistImageUrl = await this.upload_image_to_s3();
                }

                // Step 2: Create playlist with all data server-side
                await this.create_playlist_server_side(playlistImageUrl);

            } catch (error) {
                console.error('Error in playlist creation flow:', error);
                this.playlist_image_error = error.message || 'Failed to create playlist';
            } finally {
                this.create_playlist_loading = false;
                // Remove page leave protection
                window.removeEventListener('beforeunload', this.preventPageLeave);
                document.removeEventListener('turbo:before-visit', this.preventTurboNavigation);
            }
        },

        async upload_image_to_s3() {
            // Upload image to S3 and return the URL
            const dataEl = document.getElementById("ql-data-points");

            // Get upload URL for thumbnail
            const uploadUrlResponse = await fetch(`/shows/${dataEl.dataset.showId}/youtube/playlists/temp/thumbnail_upload_url`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify({
                    content_type: this.playlist_cover_art_file.type
                })
            });

            const uploadUrlData = await uploadUrlResponse.json();

            if (!uploadUrlData.success) {
                throw new Error(uploadUrlData.error || 'Failed to get upload URL');
            }

            // Upload image to S3
            const s3Response = await fetch(uploadUrlData.upload_url, {
                method: 'PUT',
                headers: uploadUrlData.headers,
                body: this.playlist_cover_art_file
            });

            if (!s3Response.ok) {
                throw new Error('Failed to upload image to S3');
            }

            // Return the S3 URL (remove query params to get clean URL)
            return uploadUrlData.upload_url.split('?')[0];
        },

        async create_playlist_server_side(playlistImageUrl) {
            // Single API call to create playlist with image server-side
            const dataEl = document.getElementById("ql-data-points");
            const createPlaylistApiUrl = dataEl.dataset.createPlaylistApiUrl;

            const requestBody = {
                title: this.new_playlist_name,
                description: this.new_playlist_description,
                privacy_status: this.new_playlist_privacy,
                use_show_cover_art: this.using_show_cover_art ? 'true' : 'false'
            };

            // Add image URL if using uploaded file
            if (playlistImageUrl) {
                requestBody.playlist_image_url = playlistImageUrl;
            }

            const createResponse = await fetch(createPlaylistApiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify(requestBody)
            });

            const createData = await createResponse.json();

            if (!createData.success) {
                throw new Error(createData.error || 'Failed to create playlist');
            }

            // Success! Add to list and select
            this.playlists.push(createData.playlist);
            this.update_playlist_dropdown();
            this.selected_playlist = createData.playlist.id;

            // Update hidden form fields with playlist info
            this.handle_playlist_selection();

            // Reset and close modal
            this.reset_playlist_modal();
        },


        reset_playlist_modal() {
            this.new_playlist_name = '';
            this.new_playlist_description = '';
            this.new_playlist_privacy = 'private';
            this.playlist_cover_art_url = '';
            this.playlist_cover_art_file = null;
            this.playlist_image_error = '';
            this.playlist_name_error = '';
            this.playlist_description_error = '';
            this.using_show_cover_art = false;
            this.new_playlist_modal = false;
        },
        preventPageLeave(event) {
            event.preventDefault();
            event.returnValue = '';
            return '';
        },
        preventTurboNavigation(event) {
            event.preventDefault();
        },
        set_data() {
            const dataEl = document.getElementById("ql-data-points");
            const scheduled_time = dataEl.dataset.scheduledAt;

            this.set_video_data();
            this.set_youtube_thumbnail_data();
            this.init_episode_state();

            // if (cover_art_url !== "") {
            //     document.querySelector("#new_cover_art").src = cover_art_url;
            //     document.querySelector("#episode_cover_art_assembly_id").value =
            //         dataEl.dataset.coverArtId;
            //     this.cover_art_upload = true;
            // }


            if (
                scheduled_time !== "" &&
                document.getElementById("ql-data-points").dataset.isPublished !== "true"
            ) {
                document.querySelector("#ql-schedule-later").checked = true;
                document.querySelector("#app_youtube_episode_scheduled_at_time").value = scheduled_time;
                document
                    .querySelector("#ql-schedule-section")
                    .classList.remove("hidden");
            }

            this.original_pub_date = dataEl.dataset.pubDate;
        },
        init_episode_state() {
            // Initialize episode state detection
            const dataEl = document.getElementById("ql-data-points");
            const episode_stage = dataEl.dataset.episodeStage;

            // Set flag for scheduled or published episodes
            this.is_scheduled_or_published = (episode_stage === 'scheduled' || episode_stage === 'published');
            this.episode_stage = episode_stage;

            // Check if YouTube is connected (playlist API URL is only present when connected)
            this.youtube_connected = !!dataEl.dataset.playlistApiUrl;
        },
        handle_update_episode() {
            // Placeholder for Update Episode functionality
            const dataEl = document.getElementById("ql-data-points");
            const episode_stage = dataEl.dataset.episodeStage;

            alert(`Update Episode button clicked!\n\nCurrent episode stage: ${episode_stage}\n\nThis is placeholder functionality - the actual update logic will be implemented later.`);

            console.log("Update Episode clicked - placeholder functionality", {
                episode_stage: episode_stage,
                is_scheduled_or_published: this.is_scheduled_or_published
            });
        },
        set_video_data() {
            const dataEl = document.getElementById("ql-data-points");
            const video_url = dataEl.dataset.videoUrl;
            const backup_video_key = dataEl.dataset.backupVideoKey;
            const youtube_video_id = dataEl.dataset.youtubeVideoId;
            const episode_stage = dataEl.dataset.episodeStage;

            // Try to get video file info from stored youtube_video_data
            let video_file_info = null;
            try {
                // Check if we have stored video data from previous draft save
                const storedVideoData = dataEl.dataset.youtubeVideoData;
                if (storedVideoData && storedVideoData !== '') {
                    const videoData = JSON.parse(storedVideoData);
                    if (videoData.draft_video_file_info) {
                        video_file_info = videoData.draft_video_file_info;
                    }
                }
            } catch (error) {
                console.error('Error parsing stored video data:', error);
            }

            // Check if episode is published on YouTube (has youtube_video_id and not draft)
            const isYoutubePublished = youtube_video_id && youtube_video_id !== "" && episode_stage !== "draft";

            if (isYoutubePublished) {
                // For published YouTube videos, embed the YouTube player instead of showing file
                this.setup_youtube_embed(youtube_video_id);
            } else if (video_url && video_url !== "") {
                // Processed video available (but not yet published to YouTube)
                this.setup_video_player(video_url, dataEl.dataset.videoFileName || "video.mp4", dataEl.dataset.videoId || "");
            } else if (backup_video_key && backup_video_key !== "") {
                // Draft video - restore from backup S3 key
                this.restore_draft_video(backup_video_key, video_file_info);
            }
        },
        setup_youtube_embed(youtube_video_id) {
            // For published YouTube videos, show embedded player and set up download functionality
            const video_container = document.getElementById("ql-uploaded-video-insert").parentNode;

            video_container.innerHTML = `
                <div class="w-full bg-gray-100 rounded-lg p-1">
                    <div class="aspect-video bg-black rounded">
                        <iframe 
                            id="ql-youtube-embed-player"
                            width="100%" 
                            height="100%" 
                            src="https://www.youtube.com/embed/${youtube_video_id}?enablejsapi=1" 
                            frameborder="0" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                            allowfullscreen
                            class="rounded h-72">
                        </iframe>
                    </div>
                </div>
            `;

            // Set up download functionality for published videos using backup_video_key
            const downloadBtn = document.getElementById("download-video-btn");
            if (downloadBtn) {
                // Remove any existing event listeners
                downloadBtn.removeEventListener("click", this.download_video_fn);

                // Add new event listener for published video download
                downloadBtn.addEventListener("click", (event) => {
                    event.preventDefault();
                    this.handle_published_video_download();
                });
            }

            this.video_upload = true; // Mark as "uploaded" to prevent validation errors
        },
        setup_video_player(video_url, filename, video_id) {
            // Set up regular video player for processed but not yet published videos
            let video_div = document.getElementById("ql-uploaded-video-insert");

            // Set up download button to open in new tab (consistent with other cases)
            const downloadBtn = document.getElementById("download-video-btn");
            if (downloadBtn) {
                // Remove any existing event listeners
                downloadBtn.removeEventListener("click", this.download_video_fn);

                // Set up direct download link that opens in new tab
                downloadBtn.href = video_url;
                downloadBtn.download = filename;
                downloadBtn.target = "_blank";
            }

            // Show video element and hide file info if it exists
            video_div.style.display = "block";
            const fileInfoDiv = document.getElementById("video-file-info");
            if (fileInfoDiv) {
                fileInfoDiv.style.display = "none";
            }

            video_div.setAttribute("src", video_url);

            // Add error handling for unsupported formats (like FLV)
            video_div.onerror = function () {
                console.warn("Video format not supported for preview, showing file info instead");
                // Create a basic file object for display
                const fileForDisplay = {
                    name: filename,
                    size: 0,
                    type: 'Unknown'
                };
                showVideoFileInfo(fileForDisplay);
            };

            video_div.onloadeddata = function () {
                handleVideoDuration();
            };

            video_div.load();
            this.video_upload = true;
            this.video_file_name = filename;
        },
        setup_video_player_with_error_handling(video_url, filename, video_id, file_info) {
            // Set up video player with same error handling as upload
            let video_div = document.getElementById("ql-uploaded-video-insert");

            // Set up download button to open in new tab (consistent with other cases)
            const downloadBtn = document.getElementById("download-video-btn");
            if (downloadBtn) {
                // Remove any existing event listeners
                downloadBtn.removeEventListener("click", this.download_video_fn);

                // Set up direct download link that opens in new tab
                downloadBtn.href = video_url;
                downloadBtn.download = filename;
                downloadBtn.target = "_blank";
            }

            // Show video element and hide file info if it exists
            video_div.style.display = "block";
            const fileInfoDiv = document.getElementById("video-file-info");
            if (fileInfoDiv) {
                fileInfoDiv.style.display = "none";
            }

            video_div.setAttribute("src", video_url);

            // Handle video load errors for unsupported formats (same as upload)
            video_div.onerror = function () {
                console.warn("Video format not supported for preview, showing file info instead");
                // Create a file-like object compatible with showVideoFileInfo (same structure as upload)
                const fileForDisplay = {
                    name: file_info?.name || filename,
                    size: file_info?.size || 0,
                    type: file_info?.type || 'Unknown'
                };
                showVideoFileInfo(fileForDisplay);
            };

            video_div.onloadeddata = function () {
                handleVideoDuration();
            };

            video_div.load();
            this.video_upload = true;
            this.video_file_name = filename;
        },
        async restore_draft_video(backup_video_key, file_info) {
            // Generate download URL for draft video and restore UI state
            const dataEl = document.getElementById("ql-data-points");
            const show_id = dataEl.dataset.showId;
            const episode_id = dataEl.dataset.episodeId;

            const filename = file_info ? file_info.name : "draft-video.mp4";

            try {
                const response = await fetch(`/shows/${show_id}/episodes/${episode_id}/generate-video-download-url`, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                    },
                    body: JSON.stringify({
                        backup_video_key: backup_video_key
                    })
                });

                const data = await response.json();

                if (data.download_url) {
                    // Set up video player with proper filename and error handling (same as upload)
                    this.setup_video_player_with_error_handling(data.download_url, filename, "", file_info);

                    // Store the file info for this session
                    this.current_video_file_info = file_info;

                } else {
                    console.warn("Failed to restore draft video:", data.error);
                }
            } catch (error) {
                console.error("Error restoring draft video:", error);
            }
        },
        async handle_published_video_download() {
            // Generate download URL for published video using backup_video_key
            const dataEl = document.getElementById("ql-data-points");
            const show_id = dataEl.dataset.showId;
            const episode_id = dataEl.dataset.episodeId;
            const backup_video_key = dataEl.dataset.backupVideoKey;

            if (!backup_video_key) {
                console.error("No backup video key found for published video");
                return;
            }

            try {
                const response = await fetch(`/shows/${show_id}/episodes/${episode_id}/generate-video-download-url`, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                    },
                    body: JSON.stringify({
                        backup_video_key: backup_video_key
                    })
                });

                const data = await response.json();

                if (data.download_url) {
                    // Open download URL in new tab
                    window.open(data.download_url, '_blank');
                } else {
                    console.error("Failed to generate download URL:", data.error);
                    alert("Failed to generate download link. Please try again.");
                }
            } catch (error) {
                console.error("Error generating download URL:", error);
                alert("Error generating download link. Please try again.");
            }
        },
        // RSS feed handling methods removed - not applicable to YouTube episodes
        has_valid_inputs(type) {
            if (type == "") {
                return false;
            }

            const dataEl = document.getElementById("ql-data-points");
            const video_url = dataEl.dataset.videoUrl;
            const titleField = document.querySelector("#app_youtube_episode_title");

            // YouTube episodes don't use season/episode numbers
            // const seasonField = document.querySelector("#app_youtube_episode_episode_season");
            // const episodeField = document.querySelector("#app_youtube_episode_episode_number");
            const scheduleField = document.querySelector(
                "#app_youtube_episode_scheduled_at_time"
            );
            const scheduleLaterField = document.querySelector("#ql-schedule-later");
            const pubDateField = document.querySelector("#app_episode_pub_date");

            let found_error = false;

            if (type == "draft") {
                // No validation required for drafts - allow saving in any state
            } else if (type == "submit") {
                // Use the comprehensive YouTube publishing validation
                if (!this.validate_youtube_publishing_requirements()) {
                    // YouTube publishing validation failed
                    found_error = true;
                    // Scroll will be handled in the validation method
                } else if (
                    document.getElementById("ql-data-points").dataset.isPublished ===
                    "true" &&
                    pubDateField.value == ""
                ) {
                    // Basically just takes out the seconds and timezone
                    // const dateString = "2024-02-28 13:10:14 UTC";
                    //
                    // const [datePart, timePart] = dateString.split(' ');
                    // const [year, month, day] = datePart.split('-');
                    // const [hours, minutes] = timePart.split(':');
                    //
                    // const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
                    document
                        .querySelector("#app_episode_pub_date")
                        ._flatpickr.setDate(this.original_pub_date);

                    this.pub_date_error = `Publication date cannot be empty or we will reset it to the original update. Please choose a publication date.`;
                    pubDateField.scrollIntoView({behavior: "smooth", block: "center"});
                    found_error = true;
                }
            }

            if (found_error) {
                return false;
            } else {
                return true;
            }
        },
        handle_submit() {
            // Check if YouTube is connected for publish/schedule actions
            if (!this.youtube_connected && this.episode_stage === 'draft') {
                // For draft episodes trying to publish/schedule, scroll to banner
                this.scroll_to_youtube_banner();
                return;
            }

            const that = this;
            const form = document.querySelector(".edit_app_youtube_episode");
            const data = this.youtube_form_data(form);
            const submitData = new URLSearchParams(data);
            let submit_type;
            let submit_action;

            // Determine what action the user wants based on radio buttons
            if (document.querySelector("#ql-schedule-now").checked) {
                submit_type = "submit";
                submit_action = "publish";
            } else if (document.querySelector("#ql-schedule-later").checked) {
                submit_type = "submit";
                submit_action = "schedule";
            } else {
                submit_type = "draft";
                submit_action = "draft";
                submitData.append("app_youtube_episode[is_draft]", "true");
            }

            // Add the submit_action parameter to tell backend exactly what user clicked
            submitData.append("app_youtube_episode[submit_action]", submit_action);

            // Validate FIRST before setting loading state
            if (this.has_valid_inputs(submit_type)) {

                // Set loading state ONLY after validation passes
                if (submit_action === "publish") {
                    this.save_text = "Publishing Episode...";
                    this.submit_disabled = true;
                } else if (submit_action === "schedule") {
                    this.save_text = "Scheduling Episode...";
                    this.submit_disabled = true;
                } else {
                    this.save_text = "Updating Episode...";
                    this.submit_disabled = true;
                }

                // Note: YouTube episodes don't need audio_file_name

                // Include video file info in youtube_video_data for draft restoration
                if (this.current_video_file_info) {
                    const youtubeVideoData = {
                        draft_video_file_info: this.current_video_file_info
                    };
                    submitData.append("app_youtube_episode[youtube_video_data]", JSON.stringify(youtubeVideoData));
                }
                (async () => {
                    const rawResponse = await fetch(form.action, {
                        method: "PATCH",
                        body: submitData,
                    });
                    const response = await rawResponse.json();

                    if (response.status === "success") {
                        window.location.href = response.link;
                    } else if (response.status === "error") {
                        that.apply_submission_errors(response.reason);
                        that.submit_disabled = false;
                        if (submitData.get("app_episode[publish_now]") === "true") {
                            that.save_text = "Publish video";
                        } else {
                            that.save_text = "Schedule video";
                        }
                        that.$refs.episode_errors.scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                        });
                    }
                })();
            } else {
                document.querySelector(".ql-submit").classList.add("border-red-400");
            }
        },
        handle_draft() {
            const that = this;
            const form = document.querySelector(".edit_app_youtube_episode");
            const data = this.youtube_form_data(form);
            const submitData = new URLSearchParams(data);

            if (this.has_valid_inputs("draft")) {
                submitData.append("app_youtube_episode[is_draft]", "true");

                // Add submit_action to indicate this is a draft save
                submitData.append("app_youtube_episode[submit_action]", "draft");

                // Include video file info in youtube_video_data for draft restoration
                if (this.current_video_file_info) {
                    const youtubeVideoData = {
                        draft_video_file_info: this.current_video_file_info
                    };
                    submitData.append("app_youtube_episode[youtube_video_data]", JSON.stringify(youtubeVideoData));
                }

                this.draft_text = "Saving...";
                this.draft_disabled = true;
                (async () => {
                    const rawResponse = await fetch(form.action, {
                        method: "PATCH",
                        body: submitData,
                    });
                    const response = await rawResponse.json();

                    if (response.status === "success") {
                        window.location.href = response.link;
                    } else if (response.status === "error") {
                        that.apply_submission_errors(response.reason);
                        that.draft_text = "Save as Draft";
                        that.draft_disabled = false;
                        that.$refs.episode_errors.scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                        });
                    }
                })();
            } else {
                document
                    .querySelector(".ql-submit-draft")
                    .classList.add("border-red-400");
            }
        },
        handle_save_and_continue(continue_to) {
            const that = this;
            const form = document.querySelector(".edit_app_youtube_episode");
            const data = this.youtube_form_data(form);
            const submitData = new URLSearchParams(data);

            // Add continue parameter to tell controller where to redirect
            submitData.append("continue_to", continue_to);

            // Add a submit_action indicating this is a save-and-continue operation
            submitData.append("app_youtube_episode[submit_action]", "save_and_continue");

            // Use basic validation (no specific submit type needed)
            if (this.has_valid_inputs("draft")) {

                // Set loading state based on continue_to direction
                if (continue_to === 'audio') {
                    this.continue_to_audio_text = "Saving...";
                    this.continue_to_audio_disabled = true;
                }

                // Include video file info in youtube_video_data
                if (this.current_video_file_info) {
                    const youtubeVideoData = {
                        draft_video_file_info: this.current_video_file_info
                    };
                    submitData.append("app_youtube_episode[youtube_video_data]", JSON.stringify(youtubeVideoData));
                }

                (async () => {
                    const rawResponse = await fetch(form.action, {
                        method: "PATCH",
                        body: submitData,
                    });
                    const response = await rawResponse.json();

                    if (response.status === "success") {
                        window.location.href = response.link;
                    } else if (response.status === "error") {
                        that.apply_submission_errors(response.reason);
                        // Reset loading state on error
                        if (continue_to === 'audio') {
                            that.continue_to_audio_text = "Go to audio set-up";
                            that.continue_to_audio_disabled = false;
                        }
                        that.$refs.episode_errors.scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                        });
                    }
                })();
            } else {
                // Show validation errors
                that.$refs.episode_errors.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
            }
        },
        check_if_audio_uploaded() {
            let that = this;
            // Audio has been properly uploaded, do nothing
            if (this.audio_upload === true) {
                return;
            }

            (async () => {
                const rawResponse = await fetch(
                    `https://api2.transloadit.com/assemblies/${that.audio_assembly_id}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );
                const content = await rawResponse.json();

                if (
                    content.ok === "ASSEMBLY_UPLOADING" ||
                    content.ok === "ASSEMBLY_EXECUTING"
                ) {
                    that.send_upload_error_notification(that.audio_assembly_id);
                }
            })();
        },
        check_if_cover_art_uploaded() {
            let that = this;
            // Audio has been properly uploaded, do nothing
            if (this.cover_art_upload === true) {
                return;
            }

            (async () => {
                const rawResponse = await fetch(
                    `https://api2.transloadit.com/assemblies/${that.cover_art_assembly_id}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );
                const content = await rawResponse.json();

                if (
                    content.ok === "ASSEMBLY_UPLOADING" ||
                    content.ok === "ASSEMBLY_EXECUTING"
                ) {
                    that.send_upload_error_notification(that.cover_art_assembly_id);
                }
            })();
        },
        init_publishing_state() {
            // Initialize the publishing state based on episode's current state
            const scheduleField = document.querySelector('#ql-schedule-later');
            const publishField = document.querySelector('#ql-schedule-now');
            const scheduleSection = document.querySelector('#ql-schedule-section');
            const scheduleDateField = document.querySelector('#app_youtube_episode_scheduled_at_time');
            const dataEl = document.getElementById("ql-data-points");
            const publish_mode = dataEl.dataset.publishMode;
            const scheduled_time = dataEl.dataset.scheduledAt;
            const isPublished = dataEl.dataset.isPublished === "true";
            // Initialize visibility preference from saved episode data FIRST
            const currentVisibility = document.querySelector('input[name="app_youtube_episode[visibility_settings]"]:checked');
            if (currentVisibility) {
                this.publish_now_visibility_preference = currentVisibility.value;
            }

            // Determine UI state based on publish_mode (not just scheduled_time)
            if (publish_mode === 'scheduled' && !isPublished) {
                // Episode is in scheduled mode - select "Schedule for later"
                if (scheduleField) {
                    scheduleField.checked = true;
                    this.save_text = 'Schedule';

                    // Show schedule section and populate date field
                    if (scheduleSection) {
                        scheduleSection.classList.remove('hidden');
                    }
                    // Note: scheduleDateField value is set in set_data() method
                }
                if (publishField) {
                    publishField.checked = false;
                }
            } else {
                // Episode is in publish_now mode or default - select "Publish now"
                if (publishField) {
                    publishField.checked = true;
                    this.save_text = 'Publish';

                    // Hide schedule section
                    if (scheduleSection) {
                        scheduleSection.classList.add('hidden');
                    }
                }
                if (scheduleField) {
                    scheduleField.checked = false;
                }
            }

            // Apply the privacy settings based on current selection
            this.handle_schedule_change();
        },
        handle_video_to_audio_choice() {
            // Handle the user's choice for video to audio conversion
            this.video_to_audio_modal = false;

            if (this.audio_choice === 'convert_video') {
                // User selected "Convert my video to an audio file"
                this.handle_convert_video_to_audio();
            } else {
                // User selected "I will upload my own audio file" - just close modal
                this.handle_upload_own_audio();
            }
        },
        async handle_convert_video_to_audio() {
            // Get the backup video key from the hidden form field
            const backupVideoKey = document.querySelector("#backup_video_key").value;
            if (!backupVideoKey) {
                console.error('Video backup key not found. Please re-upload your video.');
                return;
            }

            const dataEl = document.getElementById("ql-data-points");
            const showId = dataEl.dataset.showId;
            const episodeId = dataEl.dataset.episodeId;

            // Prepare the request body with video metadata
            const requestBody = {
                backup_video_key: backupVideoKey
            };

            // Include video file info if available (for preserving filename, size, etc.)
            if (this.current_video_file_info) {
                requestBody.video_file_info = this.current_video_file_info;
            }

            try {
                const response = await fetch(`/shows/${showId}/episodes/${episodeId}/convert-video-to-audio`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                    },
                    body: JSON.stringify(requestBody)
                });

                const data = await response.json();

                if (data.success) {
                    // Show the audio file ready confirmation modal
                    this.audio_file_ready_modal = true;
                } else {
                    console.error(`Error: ${data.error}`);
                }
            } catch (error) {
                console.error('Error starting video-to-audio conversion:', error);
            }
        },
        handle_upload_own_audio() {
            // Placeholder for when user chooses to upload their own audio
            console.info("User will upload their own audio file");
            // For now, just close the modal (already done in handle_video_to_audio_choice)
        },
        close_video_to_audio_modal() {
            this.video_to_audio_modal = false;
            this.audio_choice = 'upload_own'; // Reset to default
        },
        // Helper function to scroll to YouTube connection banner
        scroll_to_youtube_banner() {
            // Find the YouTube connection banner (it's inside the ConnectYoutubeComponent)
            const banner = document.querySelector('[x-data="connect_youtube_data()"]');
            if (banner) {
                banner.scrollIntoView({behavior: 'smooth', block: 'start'});
            } else {
                // If banner not found, scroll to top
                window.scrollTo({top: 0, behavior: 'smooth'});
            }
        },
        // Replace video modal functions
        open_replace_video_modal() {
            // Clear any previous error
            this.replace_video_error = '';

            // Check if YouTube is connected
            if (!this.youtube_connected) {
                // Set error message for scheduled/published episodes
                this.replace_video_error = 'YouTube account must be connected to replace the video';
                // Scroll to YouTube connection banner
                this.scroll_to_youtube_banner();
                return;
            }
            this.replace_video_modal = true;
        },
        handle_replace_video_choice() {
            // Clear any error
            this.replace_video_error = '';

            // Execute video reset like draft episodes
            this.video_upload = false;

            // Safely pause video elements
            const videoElement = document.getElementById('ql-uploaded-video-insert');
            if (videoElement) {
                videoElement.pause();
            }

            // Pause YouTube iframe if present (for published/scheduled episodes)
            const youtubeIframe = document.getElementById('ql-youtube-embed-player');
            if (youtubeIframe) {
                youtubeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            }

            this.video_file_name = '';
            this.replace_video_clicked = true;

            // Close modal
            this.replace_video_modal = false;
        },
        close_replace_video_modal() {
            this.replace_video_modal = false;
        },
        // Save as draft modal functions
        open_save_as_draft_modal() {
            // Check if YouTube is connected
            if (!this.youtube_connected) {
                // Scroll to YouTube connection banner
                this.scroll_to_youtube_banner();
                return;
            }
            this.save_as_draft_modal = true;
        },
        handle_save_as_draft() {
            // Handle save as draft submission for scheduled/published episodes
            // First, disable the modal button to prevent double-clicks
            const modalConfirmButton = document.querySelector('[data-save-as-draft-confirm]');
            if (modalConfirmButton) {
                modalConfirmButton.textContent = 'Converting...';
                modalConfirmButton.disabled = true;
                modalConfirmButton.classList.add('cursor-not-allowed', 'bg-gray-400', 'border-gray-400');
                modalConfirmButton.classList.remove('bg-quill-active', 'border-quill-active', 'hover:bg-quill-selected');
            }

            // Close modal and disable all action buttons
            this.save_as_draft_modal = false;

            // Change Save as Draft button text and disable all action buttons
            const draftButton = document.querySelector('.ql-submit-draft');
            if (draftButton) {
                draftButton.textContent = 'Saving...';
            }

            // Disable all action buttons to prevent user interference
            this.disable_action_buttons();

            // Get episode and show IDs from data attributes
            const dataEl = document.getElementById('ql-data-points');
            const episode_id = dataEl.dataset.episodeId;
            const show_id = dataEl.dataset.showId;

            // Create minimal request data (no video file needed for draft conversion)
            const submitData = new URLSearchParams();

            (async () => {
                try {
                    const rawResponse = await fetch(`/shows/${show_id}/episodes/${episode_id}/convert_to_draft`, {
                        method: 'POST',
                        body: submitData,
                        headers: {
                            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    });

                    const response = await rawResponse.json();

                    if (response.status === 'success') {
                        // Redirect to the view episode page to show processing status
                        window.location.href = response.redirect_url;
                    } else {
                        // Handle error response
                        console.error('Error converting to draft:', response.reason);
                        alert('Error converting episode to draft: ' + (response.reason || 'Unknown error'));

                        // Reset button states on error
                        if (draftButton) {
                            draftButton.textContent = 'Save as Draft';
                        }
                        if (modalConfirmButton) {
                            modalConfirmButton.textContent = 'Yes, save as draft';
                            modalConfirmButton.disabled = false;
                            modalConfirmButton.classList.remove('cursor-not-allowed', 'bg-gray-400', 'border-gray-400');
                            modalConfirmButton.classList.add('bg-quill-active', 'border-quill-active', 'hover:bg-quill-selected');
                        }
                        this.enable_action_buttons();
                    }
                } catch (error) {
                    console.error('Network error:', error);
                    alert('Network error occurred while converting to draft');

                    // Reset button states on error
                    if (draftButton) {
                        draftButton.textContent = 'Save as Draft';
                    }
                    if (modalConfirmButton) {
                        modalConfirmButton.textContent = 'Yes, save as draft';
                        modalConfirmButton.disabled = false;
                        modalConfirmButton.classList.remove('cursor-not-allowed', 'bg-gray-400', 'border-gray-400');
                        modalConfirmButton.classList.add('bg-quill-active', 'border-quill-active', 'hover:bg-quill-selected');
                    }
                    this.enable_action_buttons();
                }
            })();
        },
        close_save_as_draft_modal() {
            this.save_as_draft_modal = false;
        },
        // Update episode modal functions
        open_update_episode_modal() {
            // Check if YouTube is connected
            if (!this.youtube_connected) {
                // Scroll to YouTube connection banner
                this.scroll_to_youtube_banner();
                return;
            }
            this.update_episode_modal = true;
        },
        handle_update_episode_confirm() {
            // Close modal and trigger metadata update
            this.update_episode_modal = false;
            this.handle_metadata_update();
        },
        validate_metadata_for_update() {
            // Clear previous errors
            this.title_error = '';
            this.description_error = '';

            let hasError = false;

            // Check if title is provided
            const titleField = document.querySelector('input[name="app_youtube_episode[title]"]');
            if (!titleField || titleField.value.trim() === '') {
                this.title_error = 'Title cannot be empty';
                if (titleField) {
                    titleField.scrollIntoView({behavior: "smooth", block: "center"});
                }
                hasError = true;
            }

            // Check if description is provided
            const descriptionField = document.querySelector('#app_youtube_episode_description');
            if (!descriptionField || descriptionField.value.trim() === '' || descriptionField.value.trim() === '<p><br></p>') {
                this.description_error = 'Description cannot be empty';
                if (!hasError) { // Only scroll if title validation passed
                    const quillEditor = document.querySelector('.ql-editor');
                    if (quillEditor) {
                        quillEditor.scrollIntoView({behavior: "smooth", block: "center"});
                    }
                }
                hasError = true;
            }

            return !hasError && this.validate_youtube_keywords();
        },
        async handle_metadata_update() {
            // Validate required fields before submitting
            if (!this.validate_metadata_for_update()) {
                return;
            }

            // Update button states
            this.update_disabled = true;
            const updateButton = document.querySelector('.ql-update');
            if (updateButton) {
                updateButton.textContent = 'Updating...';
            }

            // Get form data
            const form = document.querySelector(".edit_app_youtube_episode");
            const formData = this.youtube_form_data(form);

            // Get update URL from data attributes
            const dataEl = document.getElementById("ql-data-points");
            const updateUrl = dataEl.dataset.updateMetadataUrl;

            if (!updateUrl) {
                console.error('Update metadata URL not found');
                this.restore_update_button();
                return;
            }

            try {
                const response = await fetch(updateUrl, {
                    method: 'PATCH',
                    body: formData,
                    headers: {
                        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                        'Accept': 'application/json'
                    }
                });

                const data = await response.json();

                if (data.redirect_url) {
                    // Always redirect when URL is provided (for success, no changes, or errors)
                    window.location.href = data.redirect_url;
                } else {
                    // Fallback for any cases without redirect URL
                    this.restore_update_button();
                    if (data.status === 'error') {
                        const errorMessage = data.reason || 'An error occurred while updating the episode';
                        this.apply_submission_errors(errorMessage);
                        this.$refs.episode_errors.scrollIntoView({ behavior: "smooth", block: "center" });
                    }
                }
            } catch (error) {
                console.error('Network error:', error);
                // For network errors, we can't redirect, so just restore the button
                this.restore_update_button();
                // Optionally show an inline error message if there's a designated error container
                const errorContainer = document.querySelector('.episode-error-message');
                if (errorContainer) {
                    errorContainer.textContent = 'A network error occurred. Please check your connection and try again.';
                    errorContainer.classList.remove('hidden');
                }
            }
        },
        restore_update_button() {
            this.update_disabled = false;
            const updateButton = document.querySelector('.ql-update');
            if (updateButton) {
                updateButton.textContent = 'Update Episode';
            }
        },
        close_update_episode_modal() {
            this.update_episode_modal = false;
        },
        disable_action_buttons() {
            // Disable all action buttons during replace video flow
            const updateButton = document.querySelector('.ql-update');
            const draftButton = document.querySelector('.ql-submit-draft');
            const submitButton = document.querySelector('.ql-submit');

            if (updateButton) {
                updateButton.disabled = true;
                updateButton.classList.add('cursor-not-allowed', 'bg-gray-400', 'border-gray-400');
                updateButton.classList.remove('bg-quill-active', 'border-quill-active');
            }
            if (draftButton) {
                draftButton.disabled = true;
                draftButton.classList.add('cursor-not-allowed', 'bg-gray-100', 'text-gray-400', 'border-gray-400');
                draftButton.classList.remove('text-quill-active', 'border-quill-active');
            }
            if (submitButton) {
                submitButton.disabled = true;
                submitButton.classList.add('cursor-not-allowed', 'bg-gray-400', 'border-gray-400');
                submitButton.classList.remove('bg-quill-active', 'border-quill-active');
            }
        },
        enable_action_buttons() {
            // Re-enable action buttons if replace video fails
            const updateButton = document.querySelector('.ql-update');
            const draftButton = document.querySelector('.ql-submit-draft');
            const submitButton = document.querySelector('.ql-submit');

            if (updateButton) {
                updateButton.disabled = false;
                updateButton.classList.remove('cursor-not-allowed', 'bg-gray-400', 'border-gray-400');
                updateButton.classList.add('bg-quill-active', 'border-quill-active');
            }
            if (draftButton) {
                draftButton.disabled = false;
                draftButton.classList.remove('cursor-not-allowed', 'bg-gray-100', 'text-gray-400', 'border-gray-400');
                draftButton.classList.add('text-quill-active', 'border-quill-active');
            }
            if (submitButton) {
                submitButton.disabled = false;
                submitButton.classList.remove('cursor-not-allowed', 'bg-gray-400', 'border-gray-400');
                submitButton.classList.add('bg-quill-active', 'border-quill-active');
            }
        },
        close_audio_file_ready_modal() {
            this.audio_file_ready_modal = false;
        },
        go_to_settings_page() {
            const dataEl = document.getElementById("ql-data-points");
            const showId = dataEl.dataset.showId;
            const settingsPage = `/shows/${showId}/distribution/show-settings#cover-art-section`;
            const titleField = document.querySelector("#app_episode_title");
            if (titleField.value === "") {
                document.location.href = settingsPage;
                return;
            }

            const that = this;
            const form = document.querySelector(".edit_app_youtube_episode");
            const data = this.youtube_form_data(form);
            const submitData = new URLSearchParams(data);
            submitData.append("app_youtube_episode[is_draft]", "true");
            this.draft_text = "Saving...";
            (async () => {
                const rawResponse = await fetch(form.action, {
                    method: "PATCH",
                    body: submitData,
                });
                const response = await rawResponse.json();
                if (response.status === "success") {
                    setTimeout(function () {
                        document.location.href = settingsPage;
                    }, 250);
                } else if (response.status === "error") {
                    that.apply_submission_errors(response.reason);
                    this.draft_text = "Save as Draft";
                    that.$refs.episode_errors.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                }
            })();
        },
        check_audio_episode_published() {
            // Check if the linked audio episode is published
            const dataEl = document.getElementById("ql-data-points");
            const audioEpisodeStage = dataEl.dataset.audioEpisodeStage;
            
            // Check if audio episode exists and is published
            this.audio_episode_published = audioEpisodeStage === 'published';
            
            // If audio episode is published, set default choice to keep current audio
            if (this.audio_episode_published) {
                this.audio_choice = 'upload_own'; // This maps to "keep current audio"
            }
        },
        check_success_modal() {
            // Check URL parameters for success modal
            const urlParams = new URLSearchParams(window.location.search);
            const modal = urlParams.get('modal');
            const action = urlParams.get('submit_action');
            const linked_state = urlParams.get('linked_state');

            if (modal === 'success' && action && linked_state) {
                this.configure_success_modal(action, linked_state);
                this.success_modal = true;

                // Clean up URL parameters
                const newUrl = window.location.pathname;
                window.history.replaceState({}, '', newUrl);
            }
        },
        configure_success_modal(action, linked_state) {
            // Configure modal content based on action and linked_state
            const isLinkedPublished = linked_state === 'published';

            if (action === 'draft') {
                this.modal_header = 'Draft saved successfully!';
                this.modal_body = 'Your video episode has been saved as a draft.';
                if (isLinkedPublished) {
                    this.modal_secondary_body = 'Your audio episode is published. You can continue editing your video or exit.';
                    this.modal_actions = [
                        {text: 'Exit', action: 'exit', primary: false},
                        {text: 'Continue to audio set-up', action: 'continue_audio', primary: true}
                    ];
                } else {
                    this.modal_secondary_body = 'What would you like to do next?';
                    this.modal_actions = [
                        {text: 'Exit', action: 'exit', primary: false},
                        {text: 'Continue to audio set-up', action: 'continue_audio', primary: true}
                    ];
                }
            } else if (action === 'scheduled') {
                this.modal_header = 'Your video has been scheduled!';
                this.modal_body = 'Once your video is done processing, we will schedule your video to YouTube.';
                if (isLinkedPublished) {
                    this.modal_header = 'Success! Both video & audio are scheduled/published.';
                    this.modal_body = 'You may now exit the page.';
                    this.modal_secondary_body = '';
                    this.modal_actions = [
                        {text: 'Got it!', action: 'exit', primary: true}
                    ];
                } else {
                    this.modal_secondary_body = 'You have not published your audio yet. What would you like to do next?';
                    this.modal_actions = [
                        {text: 'Exit', action: 'exit', primary: false},
                        {text: 'Continue to audio set-up', action: 'continue_audio', primary: true}
                    ];
                }
            } else if (action === 'published') {
                this.modal_header = 'Your video has been published!';
                this.modal_body = 'Your video episode has been published successfully.';
                if (isLinkedPublished) {
                    this.modal_header = 'Success! Both video & audio are published.';
                    this.modal_body = 'You may now exit the page.';
                    this.modal_secondary_body = '';
                    this.modal_actions = [
                        {text: 'Got it!', action: 'exit', primary: true}
                    ];
                } else {
                    this.modal_secondary_body = 'You have not published your audio yet. What would you like to do next?';
                    this.modal_actions = [
                        {text: 'Exit', action: 'exit', primary: false},
                        {text: 'Continue to audio set-up', action: 'continue_audio', primary: true}
                    ];
                }
            }
            console.log(this.modal_header, this.modal_body, this.modal_secondary_body, this.modal_actions);
        },
        handle_success_modal_action(action) {
            this.success_modal = false;

            if (action === 'exit') {
                // Route to view page
                const dataEl = document.getElementById("ql-data-points");
                const showId = dataEl.dataset.showId;
                const episodeId = dataEl.dataset.episodeId;
                window.location.href = `/shows/${showId}/episodes/${episodeId}`;
            } else if (action === 'continue_audio') {
                // Route to audio edit page
                const dataEl = document.getElementById("ql-data-points");
                const showId = dataEl.dataset.showId;
                const audioEpisodeId = dataEl.dataset.audioEpisodeId;
                window.location.href = `/shows/${showId}/episodes/${audioEpisodeId}/edit?continue_to_video=true`;
            }
        },
    }));
});

// helper function that allows us download cross-origin audio files as blob
function downloadAudioHandler(url, fileName) {
    return function (event) {
        event.preventDefault();
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.blob();
            })
            .then((blob) => {
                const link = document.createElement("a");
                const blobUrl = URL.createObjectURL(blob);
                link.href = blobUrl;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(blobUrl);
            })
            .catch((error) =>
                console.error("There was an error with the download:", error)
            );
    };
}

// helper function that allows us download cross-origin video files as blob
function downloadVideoHandler(url, fileName) {
    return function (event) {
        event.preventDefault();
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.blob();
            })
            .then((blob) => {
                const link = document.createElement("a");
                const blobUrl = URL.createObjectURL(blob);
                link.href = blobUrl;
                link.download = fileName;
                link.target = "_blank"; // Ensure new tab opening
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(blobUrl);
            })
            .catch((error) =>
                console.error("There was an error with the video download:", error)
            );
    };
}

function uppy_cover_art(alpine) {
    let signature = document.getElementById("ql-data-points").dataset.signature;
    let template_episode_cover_art_id =
        document.getElementById("ql-data-points").dataset.templateEpisodeCoverArt;

    const uppy = new Uppy({
        id: "uppy_cover_art",
        debug: true,
        autoProceed: true,
        allowMultipleUploadBatches: false,
        restrictions: {
            maxFileSize: 10 * 1024 * 1024,
            minFileSize: 1,
            maxTotalFileSize: 10 * 1024 * 1024,
            maxNumberOfFiles: 1,
            minNumberOfFiles: 1,
            allowedFileTypes: ["image/*"],
            requiredMetaFields: [],
        },
        locale: {
            strings: {
                youCanOnlyUploadFileTypes: "You can only upload image files",
            },
        },
    });

    uppy.use(Dashboard, {
        trigger: document.getElementById("episode-cover-art-uppy-trigger"),
        showProgressDetails: true,
        note: "Image must be a square and 1280px by 720px.",
    });

    uppy.use(Transloadit, {
        service: "https://api2.transloadit.com",
        params: {
            auth: {
                key: signature,
            },
            template_id: template_episode_cover_art_id,
        },
        waitForEncoding: true,
        waitForMetadata: true,
        importFromUploadURLs: false,
        alwaysRunAssembly: false,
    });

    uppy.on("upload-error", (file, error, response) => {
        if (error.isNetworkError) {
            alert(
                "The audio file was not uploading\n\n" +
                "If you are uploading from an office network, please check with your IT department regarding firewall settings. \n\n" +
                "Error: " +
                error.message
            );
        } else {
            // The error object has 2 keys which are important: error.reason, error.msg
            alpine.cover_art_error_msg = error.msg;
        }
    });

    uppy.on("transloadit:assembly-created", (assembly, fileIDs) => {
        alpine.cover_art_assembly_id = assembly.assembly_id;
    });

    uppy.on("transloadit:assembly-executing", (assembly) => {
        setTimeout(function () {
            alpine.check_if_cover_art_uploaded();
        }, 60000);
    });

    uppy.on("complete", (result) => {
        result.successful.forEach((file) => {

            document.querySelector("#new_cover_art").src = file.response.uploadURL;
            document.querySelector("#episode_cover_art_assembly_id").value =
                file.transloadit.assembly;
            alpine.cover_art_upload = true;
        });
        uppy.cancelAll();
        uppy.getPlugin("Dashboard").closeModal();
    });
}

function uppy_episode_video(alpine) {
    let signature = document.getElementById("ql-data-points").dataset.signature;
    let template_id = document.getElementById("ql-data-points").dataset.template;

    const uppy = new Uppy({
        id: "uppy_episode_video",
        debug: true,
        autoProceed: true,
        allowMultipleUploadBatches: false,
        restrictions: {
            maxFileSize: 256000 * 1024 * 1024,
            minFileSize: 300 * 1024,
            maxTotalFileSize: 256000 * 1024 * 1024,
            maxNumberOfFiles: 1,
            minNumberOfFiles: 1,
            allowedFileTypes: [
                "video/mp4",
                "video/quicktime",
                "video/mpeg",
                "video/x-msvideo",
                "video/x-ms-wmv",
                "video/x-flv",
                "video/3gpp",
                "video/webm",
                "video/x-matroska",
                ".mp4",
                ".mov",
                ".mpeg",
                ".mpg",
                ".avi",
                ".wmv",
                ".flv",
                ".3gp",
                ".webm",
                ".mkv",
                ".m4v"
            ],
            requiredMetaFields: [],
        },
        locale: {
            strings: {
                youCanOnlyUploadFileTypes: "You can only upload video files (MP4, MOV, AVI, WMV, FLV, 3GP, WebM, MKV, MPEG)",
            },
        },
    });

    uppy.use(Dashboard, {
        trigger: document.getElementById("content-uppy-trigger"),
        closeAfterFinish: true,
        showProgressDetails: true,
        hideUploadButton: true,
        singleFileFullScreen: true,
        disableStatusBar: false,
        note: "Upload any video format. Files should be 256GB or less.",
    });

    const show_id = document.getElementById("ql-data-points").dataset.showId;
    const episode_id =
        document.getElementById("ql-data-points").dataset.episodeId;

    uppy.use(AwsS3, {
        // Always use multipart for better upload performance and resilience
        shouldUseMultipart: true,
        // async getUploadParameters(file) {
        //     // https://uppy.io/docs/aws-s3/#getuploadparametersfile-options
        //     const uploadUrl = `/shows/${show_id}/episodes/${episode_id}/generate-video-upload-url`;
        //     return fetch(
        //         uploadUrl,
        //         {
        //             method: "post",
        //             headers: {
        //                 accept: "application/json",
        //                 "Content-Type": "application/json",
        //                 "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
        //                     .content,
        //             },
        //             body: JSON.stringify({
        //                 content_type: file.type,
        //             }),
        //         }
        //     )
        //         .then((response) => {
        //             return response.json();
        //         })
        //         .then((data) => {
        //             return {
        //                 method: "PUT",
        //                 url: data.presigned_url_data[0],
        //                 fields: {},
        //                 headers: data.presigned_url_data[1],
        //             };
        //         });
        // },

        // Multipart upload configuration
        async createMultipartUpload(file) {
            const response = await fetch(
                `/shows/${show_id}/episodes/${episode_id}/multipart/start`,
                {
                    method: "POST",
                    headers: {
                        accept: "application/json",
                        "Content-Type": "application/json",
                        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
                    },
                    body: JSON.stringify({
                        content_type: file.type,
                    }),
                }
            );

            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.error || 'Failed to create multipart upload');
            }

            const data = await response.json();
            return {
                uploadId: data.uploadId,
                key: data.key,
            };
        },

        async signPart(file, {uploadId, key, partNumber}) {
            const response = await fetch(
                `/shows/${show_id}/episodes/${episode_id}/multipart/sign-part`,
                {
                    method: "POST",
                    headers: {
                        accept: "application/json",
                        "Content-Type": "application/json",
                        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
                    },
                    body: JSON.stringify({
                        uploadId,
                        key,
                        partNumber,
                    }),
                }
            );

            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.error || 'Failed to sign part');
            }

            const data = await response.json();
            return {
                url: data.url,
                headers: {'Content-Type': 'application/octet-stream', ...(data.headers || {})}
            };
        },

        async completeMultipartUpload(file, {uploadId, key, parts}) {
            const response = await fetch(
                `/shows/${show_id}/episodes/${episode_id}/multipart/complete`,
                {
                    method: "POST",
                    headers: {
                        accept: "application/json",
                        "Content-Type": "application/json",
                        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
                    },
                    body: JSON.stringify({
                        uploadId,
                        key,
                        parts,
                    }),
                }
            );

            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.error || 'Failed to complete multipart upload');
            }

            const data = await response.json();
            return {
                location: data.location,
            };
        },

        async abortMultipartUpload(file, {uploadId, key}) {
            const response = await fetch(
                `/shows/${show_id}/episodes/${episode_id}/multipart/abort`,
                {
                    method: "DELETE",
                    headers: {
                        accept: "application/json",
                        "Content-Type": "application/json",
                        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
                    },
                    body: JSON.stringify({
                        uploadId,
                        key,
                    }),
                }
            );

            if (!response.ok) {
                const error = await response.json();
                console.error('Failed to abort multipart upload:', error.error);
            }
        },

        // Limit concurrent part uploads to prevent presigned URL expiration
        limit: 5
    });

    uppy.on("upload", (data) => {
        // document.querySelector("#video_uploaded").value = "";
        alpine.background_upload_text =
            "Your video is continuing to upload. To cancel, select Upload and click the X in the bottom right corner.";
    });

    uppy.on("upload-error", (file, error, response) => {
        console.error("Upload error:", {file, error, response});
        if (response && response.status === 403) {
            console.warn("Likely cause: expired presigned URL");
        }

        if (error.isNetworkError) {
            alert(
                "The video file was not uploading\n\n" +
                "If you are uploading from an office network, please check with your IT department regarding firewall settings. \n\n" +
                "Error: " +
                error.message
            );
        } else {
            // alert("The video file was not uploaded\n\n" + "Please check your internet connection and try again")
        }
    });

    uppy.on("complete", async (result) => {
        let handleReplace = false
        for (const file of result.successful) {
            const video_download_url = await getVideoPreviewLink(file);

            let video_div = document.getElementById("ql-uploaded-video-insert");

            // If video_div doesn't exist (e.g., for published episodes with YouTube embed), recreate it
            if (!video_div) {
                const video_container = document.querySelector('.rounded-lg.border.border-gray-400.bg-gray-50');
                if (video_container) {
                    video_container.innerHTML = `
                        <video class="w-full rounded" id="ql-uploaded-video-insert" controls preload="metadata" style="max-height: 300px;">
                            <source src="" type="video/mp4">
                            Your browser does not support the video element.
                        </video>
                    `;
                    video_div = document.getElementById("ql-uploaded-video-insert");
                }
            }

            // Store file info for draft saving
            alpine.current_video_file_info = {
                name: file.name,
                size: file.size,
                type: file.type || 'video/mp4'
            };

            // Extract the S3 key from uploadURL 
            let backup_key = null;
            let temp_key = null;

            if (file.uploadURL) {
                // Decode the URL first to handle URL-encoded paths
                const decodedURL = decodeURIComponent(file.uploadURL);

                // Check if this is a temp upload (for published/scheduled episodes)
                const tempParts = decodedURL.split('/temp/');
                if (tempParts.length > 1) {
                    // This is a temp upload for video replacement
                    temp_key = 'temp/' + tempParts[1].split('?')[0]; // Remove query parameters
                } else {
                    // Regular upload - extract from video/ path
                    const urlParts = decodedURL.split('/video/');
                    if (urlParts.length > 1) {
                        backup_key = 'video/' + urlParts[1].split('?')[0]; // Remove query parameters
                    }
                }
            }

            if (temp_key) {
                // For published/scheduled episodes, store temp key for replacement
                document.querySelector("#temp_video_key").value = temp_key;
                // Clear backup_video_key since we're using temp replacement
                document.querySelector("#backup_video_key").value = '';
            } else if (backup_key) {
                // For draft episodes or initial uploads, update backup_video_key
                document.querySelector("#backup_video_key").value = backup_key;
                // Clear temp_video_key since this is not a replacement
                document.querySelector("#temp_video_key").value = '';
            }

            // Store video metadata in youtube_video_data field for submission
            const videoDataField = document.querySelector('input[name="app_youtube_episode[youtube_video_data]"]');
            if (videoDataField) {
                // Get existing data or start with empty object
                let existingData = {};
                try {
                    if (videoDataField.value && videoDataField.value.trim() !== '') {
                        existingData = JSON.parse(videoDataField.value);
                    }
                } catch (e) {
                    console.warn("Failed to parse existing youtube_video_data:", e);
                    existingData = {};
                }

                // Merge in the file upload info
                const updatedData = {
                    ...existingData,
                    file_info: {
                        name: file.name,
                        size: file.size,
                        type: file.type || 'video/mp4',
                        upload_url: file.uploadURL
                    },
                    uploaded_at: new Date().toISOString()
                };
                videoDataField.value = JSON.stringify(updatedData);
            }

            // Show video element and hide file info if it exists (only if video_div exists)
            if (video_div) {
                video_div.style.display = "block";
                video_div.setAttribute("src", video_download_url.download_url);
            }

            const fileInfoDiv = document.getElementById("video-file-info");
            if (fileInfoDiv) {
                fileInfoDiv.style.display = "none";
            }

            // remove the event listener to enable us download newly uploaded video files
            document
                .getElementById("download-video-btn")
                .removeEventListener("click", alpine.download_video_fn);
            const downloadLink = document.getElementById("download-video-btn");
            downloadLink.href = video_download_url.download_url;
            downloadLink.download = file.name;
            // Ensure target="_blank" is set for new tab opening
            downloadLink.target = "_blank";

            if (video_div) {
                video_div.load();

                // Handle video load errors for unsupported formats
                video_div.onerror = function () {
                    console.log("Video format not supported for preview, showing file info instead");
                    showVideoFileInfo(file);
                };

                video_div.onloadeddata = function () {
                    handleVideoDuration();
                };
            }

            if (alpine.replace_video_clicked) {
                alpine.replace_video_clicked = false;
                // Check if this is a scheduled or published episode - if so, handle replace video flow
                if (alpine.episode_stage === 'scheduled' || alpine.episode_stage === 'published') {
                    handleReplace = true
                }
            }
            alpine.video_file_name = file.name;
            alpine.background_video_upload_text = "";
            alpine.video_upload = true;

            // Check if we should show the video-to-audio conversion modal (only for non-replace flows)
            const urlParams = new URLSearchParams(window.location.search);
            if (!handleReplace && urlParams.get('continue_to_audio') === 'true') {
                // Show modal only if linked audio episode is in draft/published/scheduled
                const dataEl = document.getElementById("ql-data-points");
                const audioStage = (dataEl && dataEl.dataset.audioEpisodeStage) ? dataEl.dataset.audioEpisodeStage : '';
                const canShowModal = ['draft', 'published', 'scheduled'].includes(audioStage);
                if (canShowModal) {
                    // Default to safest option to avoid accidental conversion
                    alpine.audio_choice = 'upload_own';
                    alpine.video_to_audio_modal = true;
                }
                // If not allowed (processing/deleting), skip modal and proceed normally
            }
        }
        uppy.cancelAll();
        uppy.getPlugin("Dashboard").closeModal();
        // Video replacement now handled through standard update flow, not immediate submission
    });

    async function getVideoPreviewLink(file) {
        return fetch(
            `/shows/${show_id}/episodes/${episode_id}/generate-video-download-url`,
            {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
                        .content,
                },
                body: JSON.stringify({
                    content_type: file.type,
                }),
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                return data;
            })
            .catch((error) => {
                console.error(error);
            });
    }
}

function handleVideoDuration() {
    const video_div = document.getElementById("ql-uploaded-video-insert");
    const time_div = document.getElementById("video-play-time");
    if (video_div && time_div) {
        video_div.addEventListener("loadedmetadata", () => {
            time_div.innerHTML = "00:00/" + convertSeconds(video_div.duration);
        });
        video_div.addEventListener("timeupdate", () => {
            time_div.innerHTML =
                convertSeconds(video_div.currentTime) +
                "/" +
                convertSeconds(video_div.duration);
        });
    }
}

function convertSeconds(seconds) {
    if (seconds >= 3600) {
        return new Date(seconds * 1000).toISOString().slice(11, 19);
    } else {
        return new Date(seconds * 1000).toISOString().slice(14, 19);
    }
}

function loadScript(url, callback) {
    let script = document.createElement("script");
    script.type = "text/javascript";

    if (script.readyState) {
        //IE
        script.onreadystatechange = function () {
            if (script.readyState === "loaded" || script.readyState === "complete") {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {
        //Others
        script.onload = function () {
            callback();
        };
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
}

function externalJS(alpine) {
    loadScript(
        "https://cdn.jsdelivr.net/npm/tom-select@1.7.6/dist/js/tom-select.complete.min.js",
        function () {
            // Handle both audio and YouTube episode keywords
            const keywordsElement = document.querySelector("#app_youtube_episode_keywords") || document.querySelector("#app_episode_keywords");
            if (keywordsElement) {
                new TomSelect(keywordsElement, {
                    plugins: {
                        remove_button: {
                            title: "Remove this tag",
                        },
                    },
                    persist: false,
                    create: true,
                    createOnBlur: true,
                    render: {
                        no_results: null,
                    },
                    createFilter: function (input) {
                        const exists = input in this.options;
                        if (exists) {
                            alpine.keyword_exists = true;
                        } else {
                            alpine.keyword_exists = false;
                        }
                        return !exists;
                    },
                    onBlur: function () {
                        alpine.keyword_exists = false;
                    },
                });
            }

            // Handle both audio and YouTube episode contributors
            const contributorsElement = document.querySelector("#app_youtube_episode_contributors") || document.querySelector("#app_episode_contributors");
            if (contributorsElement) {
                new TomSelect(contributorsElement, {
                    plugins: {
                        remove_button: {
                            title: "Remove this tag",
                        },
                    },
                    persist: false,
                    create: true,
                    createOnBlur: true,
                    render: {
                        no_results: null,
                    },
                    createFilter: function (input) {
                        const exists = input in this.options;
                        if (exists) {
                            alpine.contributor_exists = true;
                        } else {
                            alpine.contributor_exists = false;
                        }
                        return !exists;
                    },
                    onBlur: function () {
                        alpine.contributor_exists = false;
                    },
                });
            }
        }
    );

    const scheduleField = document.querySelector("#app_youtube_episode_scheduled_at_time");
    if (!scheduleField.dataset.episodeSchedulePicker) {
        flatpickr(scheduleField, {
            enableTime: true,
            minDate: Date.now(),
        });
    }
    if (
        document.getElementById("ql-data-points").dataset.isPublished === "true"
    ) {
        const pubDate = flatpickr("#app_episode_pub_date", {
            enableTime: true,
            defaultDate: document.getElementById("ql-data-points").dataset.pubDate,
            maxDate: Date.now(),
        });
    }

    const scheduleSection = document.querySelector("#ql-schedule-section");

    document
        .querySelector("#ql-schedule-later")
        .addEventListener("click", function () {
            scheduleSection.classList.remove("hidden");
        });

    document
        .querySelector("#ql-schedule-now")
        .addEventListener("click", function () {
            scheduleSection.classList.add("hidden");
        });

    let toolbar_options = [
        ["bold", "italic"],
        [{list: "ordered"}, {list: "bullet"}],
        ["link"],
        ["undo"],
        ["redo"],
        [{direction: "rtl"}],
        ["clean"],
    ];

    let icons = Quill.import("ui/icons");
    icons["undo"] = `<svg viewbox="0 0 18 18">
    <polygon class="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10"></polygon>
    <path class="ql-stroke" d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"></path>
  </svg>`;
    icons["redo"] = `<svg viewbox="0 0 18 18">
    <polygon class="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10"></polygon>
    <path class="ql-stroke" d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"></path>
  </svg>`;

    Quill.register("modules/counter", function (quill, options) {
        let container = document.querySelector(options.container);
        quill.on("text-change", function () {
            let text = quill.getText();
            let words = text.split(/\s+/).length - 1;
            let characters = text.length - 1;

            if (characters > 4000) {
                container.innerHTML = `<span class="text-red-400 font-bold">Reached limit of ${characters} characters for Apple description cutoff</span>`;
            } else if (characters === 0) {
                container.innerHTML = "";
            } else {
                container.innerHTML = `${words} words, ${characters} characters`;
            }
        });
    });
    // Initialize Quill editor
    let quill = new Quill(".ql-editor", {
        theme: "snow",
        placeholder: "Your episode description...",
        modules: {
            toolbar: {
                container: toolbar_options,
                handlers: {
                    undo: function (value) {
                        this.quill.history.undo();
                    },
                    redo: function (value) {
                        this.quill.history.redo();
                    },
                    link: function (value) {
                        if (value) {
                            var href = prompt("Enter the URL", "https://");
                            this.quill.format("link", href);
                        } else {
                            this.quill.format("link", false);
                        }
                    },
                },
            },
            history: {
                delay: 2000,
                maxStack: 500,
                userOnly: true,
            },
            counter: {
                container: "#counter",
            },
        },
    });

    let description = document.getElementById("app_youtube_episode_description");
    quill.root.innerHTML = description.value;

    quill.on("editor-change", function () {
        description.value = quill.root.innerHTML;
    });

    document.addEventListener("turbo:load load", function () {
        let description = document.getElementById("app_youtube_episode_description");
        quill.root.innerHTML = description.value;
    });
}

function uppy_youtube_thumbnail(alpine) {
    const dataEl = document.getElementById("ql-data-points");
    const show_id = dataEl.dataset.showId;
    const episode_id = dataEl.dataset.episodeId;
    const uploadUrlEndpoint = dataEl.dataset.youtubeThumbnailUploadUrl;

    const uppy = new Uppy({
        id: "uppy_youtube_thumbnail",
        debug: true,
        autoProceed: true,
        allowMultipleUploadBatches: false,
        restrictions: {
            maxFileSize: 2 * 1024 * 1024, // 2MB (YouTube requirement)
            minFileSize: 1024, // 1KB minimum
            maxTotalFileSize: 2 * 1024 * 1024,
            maxNumberOfFiles: 1,
            minNumberOfFiles: 1,
            allowedFileTypes: ['image/jpeg', 'image/png'], // YouTube requirement
            requiredMetaFields: [],
        },
        locale: {
            strings: {
                youCanOnlyUploadFileTypes: "You can only upload JPEG and PNG images for YouTube thumbnails",
            },
        },
    });

    uppy.use(Dashboard, {
        trigger: document.getElementById("youtube-thumbnail-uppy-trigger"),
        closeAfterFinish: true,
        showProgressDetails: true,
        hideUploadButton: true,
        note: "Image must be exactly 1280px by 720px. Maximum 2MB file size.",
    });

    // Validate image dimensions using Uppy's file-added event
    uppy.on('file-added', (file) => {
        // Only validate image files
        if (!file.type || !file.type.startsWith('image/')) {
            return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file.data);
        
        reader.onload = () => {
            const img = new Image();
            
            img.onload = () => {
                // Validate dimensions - must be exactly 1280x720
                if (img.width !== 1280 || img.height !== 720) {
                    // Remove the invalid file
                    uppy.removeFile(file.id);
                    
                    // Set user-friendly error message with actual dimensions
                    alpine.youtube_thumbnail_error = `You've uploaded an image that is ${img.width}x${img.height}px. We only accept images that are 1280x720px.`;
                    
                    // Close the modal
                    setTimeout(() => {
                        uppy.getPlugin('Dashboard').closeModal();
                    }, 100);
                } else {
                    // Clear error if dimensions are valid
                    alpine.youtube_thumbnail_error = "";
                }
            };
            
            img.onerror = () => {
                uppy.removeFile(file.id);
                alpine.youtube_thumbnail_error = "Unable to validate image dimensions. Please try a different image.";
                setTimeout(() => {
                    uppy.getPlugin('Dashboard').closeModal();
                }, 100);
            };
            
            img.src = reader.result;
        };
        
        reader.onerror = () => {
            uppy.removeFile(file.id);
            alpine.youtube_thumbnail_error = "Unable to read the image file. Please try again.";
            setTimeout(() => {
                uppy.getPlugin('Dashboard').closeModal();
            }, 100);
        };
    });

    uppy.use(AwsS3, {
        async getUploadParameters(file) {
            return fetch(uploadUrlEndpoint, {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
                },
                body: JSON.stringify({
                    content_type: file.type,
                }),
            })
                .then((response) => response.json())
                .then((data) => {
                    return {
                        method: "PUT",
                        url: data.presigned_url_data[0],
                        fields: {},
                        headers: data.presigned_url_data[1],
                    };
                });
        },
        shouldUseMultipart: false,
    });

    uppy.on("upload", (data) => {
        alpine.youtube_thumbnail_error = '';
    });

    uppy.on("upload-error", (file, error, response) => {
        if (error.isNetworkError) {
            alpine.youtube_thumbnail_error = "Network error during upload. Please check your connection and try again.";
        } else {
            alpine.youtube_thumbnail_error = "Failed to upload thumbnail. Please try again.";
        }
    });

    uppy.on("complete", async (result) => {
        for (const file of result.successful) {
            try {
                // Get download URL for preview
                const downloadUrlEndpoint = dataEl.dataset.youtubeThumbnailDownloadUrl;
                const response = await fetch(downloadUrlEndpoint, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                    },
                    body: JSON.stringify({
                        content_type: file.type,
                    })
                });

                const data = await response.json();

                if (data.download_url) {
                    // Extract the S3 key from uploadURL (same pattern as video)
                    let thumbnail_s3_key = null;
                    if (file.uploadURL) {
                        const urlParts = file.uploadURL.split('/video/');
                        if (urlParts.length > 1) {
                            thumbnail_s3_key = 'video/' + urlParts[1].split('?')[0]; // Remove query parameters
                        }
                    }

                    // Check if this is a replace operation for published/scheduled episodes
                    const isReplaceOperation = alpine.is_scheduled_or_published &&
                        alpine.previous_thumbnail_url &&
                        alpine.previous_thumbnail_extension;

                    // Handle replace operation - check extensions and delete old file if different
                    if (isReplaceOperation && thumbnail_s3_key) {
                        const newExtension = alpine.get_file_extension(thumbnail_s3_key);

                        // Only delete old file if extensions differ to prevent orphaned files
                        if (newExtension !== alpine.previous_thumbnail_extension) {
                            try {
                                const dataEl = document.getElementById("ql-data-points");
                                const deleteUrlEndpoint = dataEl.dataset.youtubeThumbnailDeleteUrl;
                                await fetch(deleteUrlEndpoint, {
                                    method: 'DELETE',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                                    },
                                    body: JSON.stringify({
                                        content_type: alpine.previous_thumbnail_extension === 'jpg' ? 'image/jpeg' : 'image/png'
                                    })
                                });
                                console.log('Deleted old thumbnail with different extension:', alpine.previous_thumbnail_extension);
                            } catch (error) {
                                console.error("Error deleting old thumbnail:", error);
                            }
                        }

                        // Clear previous thumbnail data after handling
                        alpine.previous_thumbnail_url = null;
                        alpine.previous_thumbnail_extension = null;
                    }

                    if (thumbnail_s3_key) {
                        // Update the hidden form field so it gets submitted with the form (save key not URL)
                        const thumbnailUrlField = document.querySelector('input[name="app_youtube_episode[youtube_thumbnail_url]"]');
                        if (thumbnailUrlField) {
                            thumbnailUrlField.value = thumbnail_s3_key;
                        }

                        // Mark that thumbnail has changed - ALWAYS for published/scheduled episodes
                        const thumbnailChangedField = document.getElementById('youtube_thumbnail_changed');
                        if (thumbnailChangedField) {
                            thumbnailChangedField.value = 'true';
                        }
                    }

                    // Update Alpine.js state
                    alpine.youtube_thumbnail_uploaded = true;
                    alpine.youtube_thumbnail_url = data.download_url; // Keep download URL for preview
                    alpine.youtube_thumbnail_error = '';

                    // Update preview element
                    const thumbnailPreview = document.getElementById("youtube-thumbnail-preview");
                    if (thumbnailPreview) {
                        thumbnailPreview.src = data.download_url;
                    }
                } else {
                    throw new Error("Failed to get download URL");
                }
            } catch (error) {
                console.warn("Error processing thumbnail upload:", error);
                alpine.youtube_thumbnail_error = "Upload completed but failed to generate preview. Please try again.";
            }
        }

        uppy.cancelAll();
        uppy.getPlugin("Dashboard").closeModal();
    });
}

function showVideoFileInfo(file) {
    const video_div = document.getElementById("ql-uploaded-video-insert");
    // const time_div = document.getElementById("video-play-time");
    // Hide the video element and show file info instead
    video_div.style.display = "none";

    // Get file size in MB
    const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);

    // Create or update file info display
    let fileInfoDiv = document.getElementById("video-file-info");
    if (!fileInfoDiv) {
        fileInfoDiv = document.createElement("div");
        fileInfoDiv.id = "video-file-info";
        fileInfoDiv.className = "w-full rounded bg-gray-100 border-2 border-dashed border-gray-300 p-6 text-center";
        video_div.parentNode.insertBefore(fileInfoDiv, video_div);
    }

    // Show the file info div if it's hidden
    if (fileInfoDiv.style.display === "none") {
        fileInfoDiv.style.display = "block";
    }
    // Show file information
    fileInfoDiv.innerHTML = `
        <div class="space-y-3">
            <svg class="w-12 h-12 mx-auto text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clip-rule="evenodd" />
            </svg>
            <div class="text-lg font-medium text-gray-900">Video Uploaded Successfully</div>
            <div class="text-sm text-gray-600">Preview not available for this format</div>
            <div class="text-xs text-gray-500 space-y-1">
                <div><strong>File:</strong> ${file.name}</div>
                <div><strong>Size:</strong> ${fileSizeMB} MB</div>
                <div><strong>Type:</strong> ${file.type || 'Unknown'}</div>
            </div>
            <div class="text-xs text-blue-600 mt-2">
                Video will be processed on YouTube when you publish.
            </div>
        </div>
    `;

    // Update time display
    // if (time_div) {
    //     time_div.innerHTML = "Duration: Unknown";
    // }
}
